module.exports = __webpack_public_path__ + "static/img/upload_user_che.9ff1f4b1.png";